import React from 'react';

export default class searchBook extends React.Component {
	constructor(){
		super()
	}
	componentDidMount(props) {
		
	}
	componentWillUnmount(){
    	//界面离开的时候
		this.setState = (state, callback)=>{
			return;
		}
	}
	render() {
		return(
			<div className={'book'}>
				电子书
		    </div>
		);
	}
}